import { gql } from 'graphql-request';
import { TaxonomySummary } from 'src/shared/types';
import { Sample } from 'src/shared/types';

export const SpeciesMapQuery = gql`
    query getSpeciesMapData($projectId: String!, $samples: sampleFilter) {
        speciesMapData: project(projectId: $projectId, samples: $samples) {
            taxonomySummary {
                taxonomy {
                    tax_species
                }
                samples
            }
            samples {
                sampleId
                sampleCollectedDatetime
                sampleReceivedDate
                location {
                    coordinates
                    type
                }
                covariates
                metrics
                provider
                source
            }
            boundingBox {
                topLeft {
                    coordinates
                }
                bottomRight {
                    coordinates
                }
            }
        }
    }
`;

type SpeciesMapData = {
    taxonomySummary: TaxonomySummary;
    samples: Pick<
        Sample,
        'sampleId' | 'location' | 'metrics' | 'covariates' | 'sampleCollectedDatetime' | 'provider' | 'source' | 'sampleReceivedDate'
    >[];
    boundingBox: {
        topLeft: {
            coordinates: [number, number];
        };
        bottomRight: {
            coordinates: [number, number];
        };
    };
};

export type SpeciesMapQueryResult = {
    speciesMapData: SpeciesMapData;
};

export const samplesSidebarQuery = gql`
    query getSpeciesMapSidebarData($projectId: String!, $samples: sampleFilter) {
        samplesSidebarData: project(projectId: $projectId, samples: $samples) {
            taxonomySummary {
                taxonomy {
                    tax_species
                    common_name
                }
                assayId
                conservationStatus {
                    iucnRedListStatus
                    chegdCommonName
                    chegdGroup
                    onGRIISList
                }
                sampleCount
                percentTotalSamples
                samples
            }
            samples {
                sampleId
                location {
                    coordinates
                    type
                }
                assays {
                    assayId
                    assayName
                    numberNamedSpecies
                }
                metrics
                provider
                source
                sampleReceivedDate
                sampleCollectedDatetime
            }
            speciesCount {
                totalSpecies
                namedSpecies
            }
        }
    }
`;

type SpeciesMapSidebarData = {
    taxonomySummary: TaxonomySummary;
    samples: Pick<
        Sample,
        'sampleId' | 'location' | 'assays' | 'metrics' | 'provider' | 'source' | 'sampleReceivedDate' | 'sampleCollectedDatetime'
    >[];
    speciesCount: {
        totalSpecies: number;
        namedSpecies: number;
    };
};

export type SpeciesMapSidebarQueryResult = {
    samplesSidebarData: SpeciesMapSidebarData;
};

export const SpeciesMapFilterQuery = gql`
    query getSpeciesMapFilterData($projectId: String!, $samples: sampleFilter) {
        SpeciesMapFilterData: project(projectId: $projectId, samples: $samples) {
            samples {
                sampleCollectedDatetime
            }
        }
    }
`;

type SpeciesMapFilterData = {
    samples: Pick<Sample, 'sampleCollectedDatetime'>[];
};

export type SpeciesMapFilterQueryResult = {
    SpeciesMapFilterData: SpeciesMapFilterData;
};
